function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#54596e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2,.cls-3{fill:#54596e;}.cls-3{opacity:0.1;}.cls-4{fill:#f99;}.cls-5{fill:#55a6ff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Walle-female");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Walle-female"
}, React.createElement("path", {
  className: "cls-1",
  d: "M48.72,16.17C48.72,9,40.79,1,31,1S13.28,9,13.28,16.17,21.21,27,31,27,48.72,23.35,48.72,16.17Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M44,15.34c0-4.46-5.82-9.41-13-9.41s-13,5-13,9.41,5.82,6.72,13,6.72S44,19.8,44,15.34Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M49,39C49,23,40.94,31,31,31S13,23,13,39s8.06,24,18,24S49,55,49,39Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M31,54c-8.92,0-16.3-6.45-17.73-19.34A30.11,30.11,0,0,0,13,39c0,16,8.06,24,18,24s18-8,18-24a30.11,30.11,0,0,0-.27-4.32C47.3,47.55,39.92,54,31,54Z"
}), React.createElement("circle", {
  className: "cls-4",
  cx: 24,
  cy: 38,
  r: 2
}), React.createElement("path", {
  className: "cls-1",
  d: "M17,39c0-7.73-1.34-10-3-10s-3-.73-3,7,1.34,21,3,21S17,46.73,17,39Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M45,39c0-7.73,1.34-10,3-10s3-.73,3,7-1.34,21-3,21S45,46.73,45,39Z"
}), React.createElement("ellipse", {
  className: "cls-5",
  cx: 36,
  cy: 15,
  rx: 3.7,
  ry: 2.47,
  transform: "translate(-2.98 16.14) rotate(-24.3)"
}), React.createElement("ellipse", {
  className: "cls-5",
  cx: 26,
  cy: 15,
  rx: 2.47,
  ry: 3.7,
  transform: "translate(1.63 32.53) rotate(-65.7)"
}));

var SvgBot = function SvgBot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bot.98beacd7.svg";
export { ForwardRef as ReactComponent };